'use client';
import { FC } from 'react';

interface HighlightedTextProps {
  text: string;
  highlightClassName?: string;
  className?: string;
}

const HighlightedText: FC<HighlightedTextProps> = ({
  text,
  className = '',
  highlightClassName = 'text-[#05F273]',
}) => {
  const parts = text.split(/(\[highlight\][^]*?\[\/highlight\])/g);

  const renderWithLineBreaks = (str: string) => {
    return str.split('\n').map((line, i, arr) => (
      <span key={i}>
        {line}
        {i < arr.length - 1 && <br />}
      </span>
    ));
  };

  return (
    <span className={className}>
      {parts.map((part, i) => {
        const match = part.match(/\[highlight\]([^]*?)\[\/highlight\]/);
        if (match) {
          return (
            <span key={i} className={highlightClassName}>
              {renderWithLineBreaks(match[1])}
            </span>
          );
        }
        return <span key={i}>{renderWithLineBreaks(part)}</span>;
      })}
    </span>
  );
};

export default HighlightedText;
